$(document).ready(function () {
  let link = $('#projectAnchorsLinks li a');
  $(link).on('click', function () {
    const parentUl = $(this).parent().parent();

    const liItems = parentUl.children();

    liItems.each(function (index, li) {
      $(li).find('a').removeClass('active');
    });

    $(this).addClass('active');
  });
});
